var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"sb-device-orientation-message"},[_c('p',[_vm._v("Please switch back to portrait mode to continue the game")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }